module.exports = __webpack_public_path__ + "img/Monte_Kope_31.2b8e3f27.jpg";